import React from 'react';
import ActionButton from '../../Common/ActionButton';

import FieldGroup from '../../Fields/FieldGroup';
import Field from '../../Fields/Field';

import { useSetAllParkersToNeutral } from '../../../Hooks/useSetAllParkersToNeutral';

const errorStyles = {
  color: 'red',
  fontWeight: 'bold'
}

function FacilityActionsPanel({ facility }) {
  const facilityId = facility.fields.uid.value;

  const {
    inProgress,
    errorMessage,
    setAllParkersToNeutral
  } = useSetAllParkersToNeutral(facilityId);

  return (
    <>
      <FieldGroup label="Access System">
        <Field label="Access System Provider" layout="columns">
          <span>{facility.fields.accessSystem.value.provider}</span>
        </Field>
      </FieldGroup>
      <ActionButton label="Set All Parkers To Neutral"
        onClick={setAllParkersToNeutral}
        inProgressState={inProgress}
      />
       {errorMessage && <p style={errorStyles}>{errorMessage}</p>}
    </>
  );
}

export default React.memo(FacilityActionsPanel);
